import './App.css';
import { Expenses } from './Components/Expenses/Expenses';
import { Main } from './Components/main/Main';

function App() {
  return (
    <div className="App">
      <Expenses/>
      <Main/>
    </div>
  );
}

export default App;
